import {
  ShoppingBasketCreationProvider as CreationProvider,
  ShoppingBasketOperationsProvider as OperationsProvider,
  ShoppingBasketPromoCodeProvider as PromoCodeProvider,
} from '#src/clientState/providers';
// Providers
import { PaymentPageProvider as PaymentPageProviderComponent } from '#src/clientState/providers/PaymentPageProvider';
import { ShoppingBasketInfoProvider as ShoppingBasketProviderVariantComponent } from '#src/clientState/providers/ShoppingBasketProvider/ShoppingBasketInfoProvider';
import { withShoppingBasketContext } from '#src/withShoppingBasketContext';
import {
  withBlockingErrorBoundary,
  withErrorBoundary,
} from '@edreamsodigeo/frontend-core';

// Hooks
export { useShoppingBasketInfo as useShoppingBasket } from '#src/clientState/providers/ShoppingBasketProvider/ShoppingBasketInfoProvider';

export { useShoppingBasketCreation } from '#src/clientState/providers/ShoppingBasketProvider';

export { useShoppingBasketOperations } from '#src/clientState/providers/ShoppingBasketProvider/ShoppingBasketOperationsProvider';

export { useShoppingBasketPaymentPage } from '#src/clientState/hooks/useShoppingBasketPaymentPage';

export { useProductsSummaryConfigurator } from '#src/clientState/hooks/useProductsSummaryConfigurator';

export { useBundlesSummaryConfigurator } from '#src/clientState/hooks/useBundlesSummaryConfigurator';

export { useShoppingBasketPromoCodes } from '#src/clientState/providers';

export const PaymentPageProvider = withShoppingBasketContext(
  withBlockingErrorBoundary(PaymentPageProviderComponent, {
    name: 'PaymentPageProvider',
  })
);

export const ShoppingBasketProvider = withBlockingErrorBoundary(
  ShoppingBasketProviderVariantComponent,
  {
    name: 'ShoppingBasketProvider',
  }
);

export const ShoppingBasketCreationProvider = withBlockingErrorBoundary(
  CreationProvider,
  {
    name: 'ShoppingBasketCreationProvider',
  }
);

export const ShoppingBasketOperationsProvider = withBlockingErrorBoundary(
  OperationsProvider,
  { name: 'ShoppingBasketOperationsProvider' }
);

export const ShoppingBasketPromoCodeProvider = withErrorBoundary(
  PromoCodeProvider,
  { name: 'ShoppingBasketPromoCodeProvider' }
);

export { useGetShoppingBasketByIdParam } from '../providers/ShoppingBasketProvider/ShoppingBasketInfoProvider.hook';
